import React from "react";
import { Link } from "react-router-dom";
import "./HeroSection.css";

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-image-container">
        <video
          className="hero-video"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        >
          <source src="/videos/hero3_video.mp4" type="video/mp4" />
        </video>
        <div className="hero-overlay"></div>
      </div>

      <div className="hero-content">
        <div className="container">
          <h1 className="hero-title">
            <span className="hero-title-text">
              <span className="hero-title-think">Think Bigger.</span>{" "}
              <span className="hero-title-rise">Rise Faster.</span>
            </span>
          </h1>
          <p className="hero-subtitle">
           The ultimate B2B intelligence engine for high-growth enterprises. We deliver precision-vetted data across Healthcare, Tech, and Global Conferences to put your sales team in front of the right decision-makers—anywhere in the world.
          </p>
          <div className="hero-buttons">
            <Link to="/contact" className="btn hero-btn primary">
              Start a Consultation
            </Link>
            <Link to="/solutions" className="btn hero-btn secondary">
              View Solutions
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
